export default {
  state: {
    cisbaSubcategoryData: {},
  },

  getters: {
    getCisbaSubcategoryData(state) {
      return state.cisbaSubcategoryData;
    },
  },

  mutations: {
    setCisbaSubcategoryData(state, data) {
      const isNull = data === null;

      state.cisbaSubcategoryData = {
        id: !isNull ? data.id : "",
        name: !isNull ? data.name : "",
      };
    },
  },

  actions: {
    changeCisbaSubcategoryData(context, infos) {
      context.commit("setCisbaSubcategoryData", infos);
    },
  },
};
